const router = function (permissions) {
  return ({
    path: 'administradores',
    component: () => import('@/views/Administrador/AdministradorModule.vue'),
    meta: { permissions },
    children: [
      {
        path: '/',
        component: () => import('@/views/Administrador/AdministradorList.vue'),
        meta: { permissions, title: 'Manutenção de Administradores' },
      },
      {
        path: 'cadastrar',
        component: () => import('@/views/Administrador/AdministradorProfile.vue'),
        meta: { permissions, title: 'Cadastrando Administrador' },
      },
      {
        path: 'alterar',
        component: () => import('@/views/Administrador/AdministradorProfile.vue'),
        meta: { permissions, title: 'Editando Administrador' },
      },
    ],
  })
}

export default {
  router,
}
